import React from 'react';
import { Form } from 'react-bootstrap';
import "../../css/Contact.css";
import useProvider from '../../Hooks/useProvider';
import emailjs from 'emailjs-com';
import contactImg from "../../images/contact.svg";
const Contact = () => {

    const data = useProvider();

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_9592iwb', 'template_1run9vn', e?.target, 'user_oC2CxWXB7E0IIrOMc0EYB')
            .then((res) => {
                e.target.reset();
            }).catch((err) => {
                alert(err.message);
            });
    }

    return (
        <div className="contact container px-2">
            <h1 className="contact__heading">CONTACT ME</h1>
            <div className="contact__container">
                <div className="contact__left">
                    <img src={contactImg} alt="" />
                </div>
                <div className="contact__right">
                    <Form onSubmit={handleSubmit} className="form">
                        <Form.Group className="mb-3" >
                            <Form.Control required name="user_name" className="form__field" type="text" placeholder="Full Name" />

                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Control required name="user_email" className="form__field" type="email" placeholder="your Email" />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control required name="user_subject" className="form__field" type="text" placeholder="your subject" />

                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control required name="message" className="form__field" rows="4" as="textarea" placeholder="type your message here" />
                        </Form.Group>

                        <button className="form__submit" type="submit">
                            Submit
                        </button>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default Contact
